import SessionEventProto from "../session-event-proto"
import AppMyNotes from "../../../views/notepad/app"
import {GooddayApp} from "../../gd-app/apps";

const debug = false
// const debug = "SessionNotepadDelta"

export default class SessionNotepadDelta extends SessionEventProto {

    process() {

        let app = gd.getApp() as unknown as AppMyNotes

        debug && console.log(debug, 'process', this.fromSID, gd.sessionId, app)

        if (app.name !== GooddayApp.NOTEPAD) return

        // Ignore session events that has been initialized by this browser tab (SID)
        if (this.fromSID === gd.sessionId) {
            debug && console.log(debug, 'process: same tab -> ignore')
            return false
        }

        app.resetDataFromSessionEvent(this.sessionEvent.data.notesData)
    }
}
